<template>
    <div class="card border-0 rounded" style="box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.10), 0 6px 10px 0 rgba(0, 0, 0, 0.01); overflow: hidden; height: 100%">
      <div class="card bg-image border-0 m-0 p-0" style="position: absolute; top: 0px; bottom: 60px; right: 0px; left: 0px;">
        <div class="card border-0 m-0 p-0 position-relative bg-transparent" style="overflow-y: auto; height: 100%;" v-chat-scroll>
          <div class="p-2 m-0 position-relative" v-bind:class="{ 'balon1': chat.user === nickname, 'balon2': chat.user !== nickname }" v-for="chat in chats" :key="chat.key" 
          :data-is="chat.user + ' - ' + moment(chat.sendDate).fromNow()">
            <!-- <div v-if="chat.type==='join'|| chat.type==='exit'" v-bind:class="{ 'float-right': chat.user === nickname, 'float-left': chat.user !== nickname }"> {{chat.message}} </div> -->
            <!-- <span v-else> {{chat.message}} </span> -->
            <span v-if="chat.type ==='newmsg'"> {{chat.message}} </span>
          </div>			
      </div>
    </div>

    <div class="w-100 card-footer p-2 bg-light border border-bottom-0 border-left-0 border-right-0">	
        <form class="m-0 p-0" @submit="onSubmit" method="POST" autocomplete="off">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Type a message..." v-model.trim="data.message">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary border" type="submit" v-on:click="onSubmit" :disabled="!data.message">
              Send 
              <!-- <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M3.4 20.4l17.45-7.48c.81-.35.81-1.49 0-1.84L3.4 3.6c-.66-.29-1.39.2-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z"/>
              </svg> -->
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script>

import firebase from '../Firebase'
import router from '../router'

export default {
  name: 'Chat',
  data () {
    return {
        roomid: this.$route.params.roomid,
        roomname: this.$route.params.roomname,
        nickname: this.$route.params.nickname,
        data: { type:'', nickname:'', message:'' },
        chats: [],
        errors: [],
        offStatus: false
    }
  },
  created () {
    // let joinData = firebase.database().ref('chatrooms/'+this.roomid+'/chats').push();
    // joinData.set({
    //   type: 'join',
    //   user: this.nickname,
    //   message: this.nickname+' has joined this room.',
    //   sendDate: Date()
    // });
    this.data.message = '';
    firebase.database().ref('chatrooms/'+this.roomid+'/chats').on('value', (snapshot) => {
      this.chats = [];
      snapshot.forEach((doc) => {
        let item = doc.val()
        item.key = doc.key
        this.chats.push(item)
      });
    });
  },
  methods: {
    onSubmit (evt) {
        evt.preventDefault()

        let newData = firebase.database().ref('chatrooms/'+this.roomid+'/chats').push();
        newData.set({
            type: 'newmsg',
            user: this.nickname,
            message: this.data.message,
            sendDate: new Date().toISOString()
        });
        this.data.message = '';
    },
    exitChat () {
      let exitData = firebase.database().ref('chatrooms/'+this.roomid+'/chats').push()
      exitData.set({
        type: 'exit',
        user: this.nickname,
        message: this.nickname+' has exited this room.',
        sendDate: Date()
      })

      this.offStatus = true
      router.go(-1)
    }
  }
}
</script>

<style>
body {
	background: #ddd;
}

span {		
	text-decoration: none !important;
}
		
.btn:focus, .btn:active:focus, .btn.active:focus {
	outline: none !important;
	box-shadow: 0 0px 0px rgba(120, 144, 156,1.0) inset, 0 0 0px rgba(120, 144, 156,0.8);
}


textarea:focus,
input[type="text"]:focus,
input[type="password"]:focus,
input[type="datetime"]:focus,
input[type="datetime-local"]:focus,
input[type="date"]:focus,
input[type="month"]:focus,
input[type="time"]:focus,
input[type="week"]:focus,
input[type="number"]:focus,
input[type="email"]:focus,
input[type="url"]:focus,
input[type="search"]:focus,
input[type="tel"]:focus,
input[type="color"]:focus,
.uneditable-input:focus {   
	border-color: rgba(120, 144, 156,1.0); color: rgba(120, 144, 156,1.0); opacity: 0.9;
	box-shadow: 0 0px 0px rgba(120, 144, 156,1.0) inset, 0 0 10px rgba(120, 144, 156,0.3);
	outline: 0 none;
}

.card::-webkit-scrollbar {
    width: 1px;
}
 
::-webkit-scrollbar-thumb {
    border-radius: 9px;
	background: rgba(96, 125, 139,0.99);
}

.balon1, .balon2 {
	margin-top: 5px !important;
	margin-bottom: 5px !important;
}


.balon1 span {
	background: #3e4042;
	color: #fff !important;
	border-radius: 20px 20px 3px 20px;
	display: block;
	max-width: 75%;
  padding: 7px 13px 7px 13px;
  float: right;
}

.balon1:before {
	content: attr(data-is);
	position: absolute;
	right: 15px;
	bottom: -0.8em;
	display: block;
	font-size: .750rem;
	color: rgba(84, 110, 122,1.0);
}

.balon2 span {
	background: #f1f1f1;
	color: #000 !important;
	border-radius: 20px 20px 20px 3px;
	display: block;
	max-width: 75%;
  padding: 7px 13px 7px 13px;
  float: left;
}
	
.balon2:before {
	content: attr(data-is);
	position: absolute;
	left: 13px;
	bottom: -0.8em;
	display: block;
	font-size: .750rem;
	color: rgba(84, 110, 122,1.0);
}
	
.card-footer {
  position: absolute;
  bottom: 0px;
  height: 60px;
}
</style>